module.exports = __webpack_public_path__ + "static/media/soul_decorative_line.abafb616.png";